import $ from 'jquery';
export default {
  init() {

    window.onload = function() {
      const submenus = document.getElementsByClassName('submenu');
      for (let i = 0; i < submenus.length; i++) {
        submenus[i].removeAttribute('style');
      }
      // append the plus icon to all dropdown menus
      $('.menu-item-has-children > a').append('<i class="fal fa-plus"></i>');
    }

    // smooth scroll when an id link is clicked
    $('.smooth-scroll').click(function(e) {
      const id = e.currentTarget.hash;
      $('html, body').animate({
          scrollTop: $(id).offset().top,
      }, 1000);
    });

    // prevent default on three colump layout titles
    $('.prevent-default').click(function(e) {
      e.preventDefault();
    })

    // JavaScript to be fired on all pages
    // Toggle mobile navigation visibility
    const navWrapper = document.getElementById('nav-wrapper')
    window.toggleNav = function() { //esline-disable-line
      navWrapper.classList.toggle('visible');
      document.querySelector('.hamburger').classList.toggle('is-active');
      document.querySelector('body').classList.toggle('disable-scroll');
      document.querySelector('html').classList.toggle('disable-scroll');
      if (document.querySelector('.hamburger.is-active')) {
        const nav = document.querySelector('.nav-wrapper');
        const hamburger = document.querySelector('.hamburger');
        document.addEventListener('click', function(event) {
          var isClickInside = nav.contains(event.target);
          var isClickHamburger = hamburger.contains(event.target);
        
          if (!isClickInside && !isClickHamburger) {
            //the click was outside the nav, close the nav
            navWrapper.classList.remove('visible')
            document.querySelector('.hamburger').classList.remove('is-active');
            document.querySelector('body').classList.remove('disable-scroll');
            document.querySelector('html').classList.remove('disable-scroll');
          }
        });
      }
    } 

    // remove links from parent dropdown menu items
    const dropdowns = document.getElementsByClassName('menu-item-has-children');
    for (let i = 0; i < dropdowns.length; i++) {
      dropdowns[i].firstElementChild.setAttribute('href', '#');

      // listen for click of parent menu item
      dropdowns[i].addEventListener('click', function() {
        dropdowns[i].lastElementChild.classList.toggle('show-child-menu');
      })
    }

    // header sticky on scroll up
    // Hide Header on on scroll down
    var c, currentScrollTop = 0,
        navbar = document.querySelector('.site-header');
  
    window.addEventListener('scroll', function() {
        var a = window.pageYOffset;
        var b = navbar.offsetHeight;
      
        currentScrollTop = a;
      
        if (c < currentScrollTop && a > b + b) {
          navbar.classList.add('header-up');
        } else if (c > currentScrollTop && !(a <= b)) {
          navbar.classList.remove('header-up');
        }
        c = currentScrollTop;
    });

    
    // stops the default behaviour of the enter key when the calc is focused
    // listen for the focus of the medication search input
    const rxSearch = document.getElementById('medication-search');
    if (rxSearch) {
      rxSearch.addEventListener('focus', function() {
  
        document.addEventListener('keypress', function(e) {
          // listen for enter key
          if (e.keyCode === 13 || e.keyCode === 'Enter') {
            e.preventDefault();
          }
        })
      })
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js